
import {Component, Vue} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {getOperateLog, LogListApi} from "@/api/order";
import {getStoreOrderOperateLog} from '@/api/industryMall'
Component.registerHooks(['beforeRouteEnter']);

@Component({
  name: 'Log'
})
export default class Log extends Vue {
  @Getter companyId!: string

  params = {
      isReturn: true, // 是否是退货单 Boolean
      storeId: "",
      // currRouteId: '',
      orderId: "",
      isValid: "Y",
  }
  logList: LogListApi[] = []

  beforeRouteEnter(to, from, next) {
      if (to.query.isReturn === '1') {
          to.meta.title = '退单日志'
      } else{
          to.meta.title = '订单日志'
      }
      next();
  }

  created() {
      // this.params.companyId = this.companyId
      this.params.storeId = this.$route.query.storeId as string
      this.params.orderId = this.$route.query.orderId as string
      this.params.isReturn = this.$route.query.isReturn === '1'
      this.getNodeList()
  }

  getNodeList() {
       getStoreOrderOperateLog(this.params).then((res) => {
          this.logList = res.data || []
       })
  }
}
